import React from 'react'
import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../../shared/SectionCard'
import InfoItem from '../../shared/InfoItem'
import './style.css'

const APLINK = import.meta.env.VITE_API_URL

const BasicInformation = ({ requestDetails }) => {
    const { t } = useTranslation()

    return (
        <SectionCard icon="mdi:hospital-building" titleKey="basic-information">
            <div className="basic-info-content">
                <div className="hospital-image-wrapper">
                    <img 
                        src={`${APLINK}/${requestDetails?.logo}`} 
                        alt="Hospital" 
                        className="hospital-main-image"
                        onError={(e) => e.target.src = './images/hospital-placeholder.jpg'}
                    />
                </div>
                
                <div className="hospital-basic-details">
                    <div className="hospital-name-section">
                        <div className="hospital-name-badge">
                            <Icon icon="mdi:hospital-building" className="hospital-name-icon" />
                            <h3 className="hospital-name-text">
                                {requestDetails?.providerName}
                            </h3>
                        </div>
                    </div>

                    <div className="hospital-info-grid">
                        <InfoItem 
                            icon="mdi:map-marker" 
                            labelKey="MainAddress" 
                            value={requestDetails?.mainAddress} 
                        />

                        <InfoItem 
                            icon="mdi:city" 
                            labelKey="service-type" 
                            value={requestDetails?.serviceType} 
                        />

                        {requestDetails?.locations?.slice(0, 4).map((location, index) => (
                            <InfoItem 
                                key={index}
                                icon="mdi:map-marker" 
                                labelKey="locations" 
                                value={location} 
                            />
                        ))}
                    </div>

                    <div className="hospital-description">
                        <p>{requestDetails?.profileSummary}</p>
                    </div>
                </div>
            </div>
        </SectionCard>
    )
}

export default BasicInformation

